import React, { useMemo } from 'react';
import {
  ButtonApprove,
  FieldCheckBox,
  FieldInput,
  FieldNumericInput,
  FieldTextArea,
  FormCol,
  FormCol2,
} from 'motion-components';
import { useFormikContext } from 'formik';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { useTranslation } from 'react-i18next';
import { dateField, isActiveField } from 'shared-pages/common/form-helpfunc';
import { Col } from 'react-bootstrap';
import { FileRepoField } from 'shared-pages/components/filerepo-field';
import { FieldSelectCollector } from 'shared-pages/components';
import { isFotokiklosi, isRebattery, isRebatteryLiion } from 'shared-pages/common/constants';

export const FormFields = ({ isNew, updateRecord, refetch, data, handleApprove }) => {
  //
  const frmkCntx = useFormikContext();
  const { values } = frmkCntx;
  const { appStore, authStore } = useRootStore();
  const { handleGraphqlError } = useHandleError('VehicleFormFields');
  const { t } = useTranslation();

  const { canEdit, canEditReasoning } = useMemo(() => {
    let canEdit = appStore.isPlatformOwner || appStore.isCollector || isNew;
    if (isRebattery || isRebatteryLiion) {
      canEdit = appStore.isPlatformOwner || isNew;
    } else if (isFotokiklosi) {
      canEdit = appStore.isPlatformOwner || isNew;
    }
    const canEditReasoning = '';
    return { canEdit, canEditReasoning };
  }, [appStore.isPlatformOwner, appStore.isCollector, isNew]);

  return (
    <>
      <div className="d-flex flex-row">
        {/* 1η Στήλη */}
        <FormCol>
          <FieldInput
            label={t('Αριθμός Κυκλοφορίας Οχήματος')}
            name="plateNumber"
            placeholder=""
            disabled={!canEdit}
          />
          <FieldSelectCollector disabled={!canEdit} label={t('Συλλέκτης')} name="collectorId" />
          <FieldTextArea
            disabled={!canEdit}
            label={t('Σχόλια')}
            name="notes"
            type="text"
            rows={5}
            placeholder={t('')}
            required={false}
          />
        </FormCol>

        {/* 2η Στήλη */}
        <FormCol>
          <FieldNumericInput
            disabled={!canEdit}
            min={1}
            label={t('Μικτό Φορτίο')}
            name="grossWeight"
          />
          <FieldNumericInput
            disabled={!canEdit}
            min={1}
            label={t('Οφέλιμο Φορτίο')}
            name="payloadWeight"
          />

          <FileRepoField
            as={Col}
            label={t('Ανάρτηση Άδειας Κυκλοφορίας Οχήματος')}
            fileIdFieldName="licenseFileId"
            fileRec={data?.licenseFilesrepository}
          />
        </FormCol>
        {/* 3η Στήλη */}
        <FormCol>
          {isActiveField(t, canEdit)}
          {appStore.isPlatformOwner && (
            <>
              <FieldCheckBox
                disabled={true}
                as={'div'}
                label={t('Εγκεκριμένο Όχημα')}
                name="isApproved"
                onLabel={t('ΝΑΙ')}
                offLabel={t('ΟΧΙ')}
              />
              <FieldInput label={t('Έγκριθηκε από')} name="approvedBy" disabled={true} />
              {dateField(t('Ημ/νία Έγκρισης'), 'approvedDate', t, false)}
              {data?.isApproved === false && (
                <ButtonApprove
                  onClick={() => handleApprove()}
                  text={t('Έγκριση Άδειας Κυκλοφορίας')}
                  className="col-12"
                />
              )}
            </>
          )}
        </FormCol>
      </div>
    </>
  );
};
